export enum ResourceType {
  CMG_STREET_MEDICINE_APPOINTMENT_ID = 'cmg-street-medicine-appointment',
}
